export default "__VITE_ASSET__534836b0__"